/* ============================================================
   ALPHA EYEWEAR THEME — GLOBAL JS
   Live cart drawer + add-to-cart via Shopify's AJAX Cart API.
   ============================================================ */
(function () {
  var cfg = window.AlphaTheme || { currency: 'USD', freeShipCents: 0, routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };

  var drawer = document.querySelector('[data-al-cart-drawer]');
  var overlay = document.querySelector('[data-al-cart-overlay]');

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cfg.currency });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function openCart() {
    refreshCart().then(function () {
      if (!drawer) return;
      drawer.classList.add('al-open');
      if (overlay) overlay.classList.add('al-open');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('al-open');
    if (overlay) overlay.classList.remove('al-open');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-al-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.querySelectorAll('[data-al-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function refreshCart() {
    return fetch(cfg.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-al-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var sub = document.querySelector('[data-al-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);

        // Free shipping progress
        var msg = document.querySelector('[data-al-ship-msg]');
        var fill = document.querySelector('[data-al-ship-fill]');
        var wrap = document.querySelector('[data-al-ship-wrap]');
        if (msg && fill) {
          if (cfg.freeShipCents > 0) {
            var remaining = cfg.freeShipCents - cart.total_price;
            if (remaining <= 0) {
              msg.innerHTML = "🎉 You've unlocked <span>FREE shipping!</span>";
              fill.style.width = '100%';
            } else {
              msg.innerHTML = "You're <span>" + money(remaining) + " away</span> from free shipping! 🚚";
              fill.style.width = Math.min(100, (cart.total_price / cfg.freeShipCents) * 100) + '%';
            }
          } else if (wrap) {
            wrap.style.display = 'none';
          }
        }

        // Line items
        var itemsWrap = document.querySelector('[data-al-cart-items]');
        if (!itemsWrap) return cart;
        if (cart.items.length === 0) {
          itemsWrap.innerHTML = '<div class="al-cart-empty">Your cart is empty.<br>Time to gear up. 🕶</div>';
          return cart;
        }
        itemsWrap.innerHTML = cart.items.map(function (item, i) {
          var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x$1$2') : '';
          return '<div class="al-cart-item">' +
            '<div class="al-cart-item-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div style="flex:1;">' +
              '<a href="' + item.url + '"><div class="al-cart-item-name">' + item.product_title + '</div></a>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="al-cart-item-variant">' + item.variant_title + '</div>' : '') +
              '<div class="al-cart-item-row">' +
                '<div class="al-cart-qty">' +
                  '<button type="button" data-al-qty="' + (i + 1) + ':' + (item.quantity - 1) + '" aria-label="Decrease quantity">\u2212</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-al-qty="' + (i + 1) + ':' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="al-cart-item-price">' + money(item.final_line_price) + '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');

        itemsWrap.querySelectorAll('[data-al-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var parts = btn.getAttribute('data-al-qty').split(':');
            fetch(cfg.routes.cartChange + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: parseInt(parts[0], 10), quantity: Math.max(0, parseInt(parts[1], 10)) })
            }).then(function () { refreshCart(); });
          });
        });
        return cart;
      });
  }

  function addToCart(variantId, qty, btn) {
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    return fetch(cfg.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (btn) { btn.textContent = '✓ Added'; btn.disabled = false; setTimeout(function () { btn.textContent = original; }, 1500); }
      openCart();
    }).catch(function () {
      if (btn) { btn.textContent = 'Try again'; btn.disabled = false; setTimeout(function () { btn.textContent = original; }, 1500); }
    });
  }

  // Any element with data-al-atc="VARIANT_ID" becomes an add-to-cart button (event delegation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-al-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn.getAttribute('data-al-atc'), 1, btn);
  });

  // Product page form: intercept and add via AJAX
  document.querySelectorAll('form[data-al-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      addToCart(id, qty, form.querySelector('[type="submit"]'));
    });
  });

  // Product page thumbnail gallery
  document.querySelectorAll('[data-al-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-al-main-img]');
      if (main) main.src = thumb.getAttribute('data-al-thumb');
      document.querySelectorAll('[data-al-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  // Variant select → update price + button state
  document.querySelectorAll('[data-al-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var priceEl = document.querySelector('[data-al-product-price]');
      var wasEl = document.querySelector('[data-al-product-was]');
      var submit = document.querySelector('form[data-al-product-form] [type="submit"]');
      if (priceEl && opt.dataset.price) priceEl.textContent = money(parseInt(opt.dataset.price, 10));
      if (wasEl) {
        var cmp = parseInt(opt.dataset.compare || '0', 10);
        var prc = parseInt(opt.dataset.price || '0', 10);
        wasEl.textContent = cmp > prc ? money(cmp) : '';
      }
      if (submit) {
        var available = opt.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  // Mobile menu
  var toggle = document.querySelector('[data-al-menu-toggle]');
  var mobileMenu = document.querySelector('[data-al-mobile-menu]');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- GLOBAL SALE COUNTDOWN ----------
     One timer, shared by every section that shows urgency (announcement
     bar, hero, flash sale banner, sticky add-to-cart). Reads the single
     sale end date set in Theme Settings → Sale & Urgency. Once it passes,
     every element flagged .al-timer-el is hidden site-wide — no section
     ever shows a fake or stale countdown. */
  var saleEnd = cfg.saleEnd ? new Date(cfg.saleEnd) : null;

  function updateTimers() {
    if (!saleEnd || isNaN(saleEnd.getTime()) || saleEnd - new Date() <= 0) {
      document.documentElement.classList.add('al-timer-hidden');
      return;
    }
    var diff = Math.floor((saleEnd - new Date()) / 1000);
    var d = Math.floor(diff / 86400);
    var h = String(Math.floor((diff % 86400) / 3600)).padStart(2, '0');
    var m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
    var s = String(diff % 60).padStart(2, '0');
    var fmt = (d > 0 ? d + 'd ' : '') + h + ':' + m + ':' + s;
    document.querySelectorAll('[data-al-timer]').forEach(function (el) { el.textContent = fmt; });
    document.querySelectorAll('[data-al-th]').forEach(function (el) { el.textContent = String(d * 24 + parseInt(h, 10)).padStart(2, '0'); });
    document.querySelectorAll('[data-al-tm]').forEach(function (el) { el.textContent = m; });
    document.querySelectorAll('[data-al-ts]').forEach(function (el) { el.textContent = s; });
  }
  updateTimers();
  setInterval(updateTimers, 1000);

  /* ---------- TICKER LOOP (duplicates track content so it can scroll seamlessly) ---------- */
  document.querySelectorAll('[data-al-ticker]').forEach(function (t) { t.innerHTML += t.innerHTML; });
  document.querySelectorAll('[data-toroe-ticker]').forEach(function (t) { t.innerHTML += t.innerHTML; });

  /* ---------- TOROE-STYLE HERO SLIDESHOW ---------- */
  document.querySelectorAll('[data-toroe-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-toroe-slide]');
    var dots = root.querySelectorAll('[data-toroe-dot]');
    if (slides.length <= 1) return; // nothing to rotate
    var current = 0;
    var seconds = parseInt(root.dataset.autoplaySeconds, 10) || 5;

    function goTo(i) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); resetTimer(); }); });
    var prevBtn = root.querySelector('[data-toroe-prev]');
    var nextBtn = root.querySelector('[data-toroe-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    var timer = setInterval(function () { goTo(current + 1); }, seconds * 1000);
    function resetTimer() { clearInterval(timer); timer = setInterval(function () { goTo(current + 1); }, seconds * 1000); }
  });

  /* ---------- STICKY ATC reveal on scroll ---------- */
  var sticky = document.querySelector('[data-al-sticky]');
  if (sticky) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('al-show', window.scrollY > 600);
    }, { passive: true });
  }

  // Expose for sections & keep counts fresh on load
  window.AlphaCart = { open: openCart, close: closeCart, refresh: refreshCart, add: addToCart };
  refreshCart();
})();
